module.exports = __webpack_public_path__ + "static/media/hero_video.14182558.jpg";